import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { ToastService } from '../../services/toast.service';
import { ConfirmService } from '../../services/confirm.service';
import { Fattura } from '../../models';

@Component({
  selector: 'app-fatture',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  template: `
    <div class="page-container">
      <div class="header-flex">
        <div>
          <h1>Gestione Fatture</h1>
          <p class="subtitle">Elenco fatture e proforma</p>
        </div>
        <a routerLink="/fatture/nuova" class="btn-primary">
          <span class="material-icons" style="font-size: 18px;">post_add</span> Nuova Fattura
        </a>
      </div>

      <!-- Search Bar -->
      <div class="search-bar card">
        <span class="material-icons search-icon">search</span>
        <input type="text" [(ngModel)]="searchTerm" placeholder="Cerca per numero fattura, cliente o stato..." />
        <button *ngIf="searchTerm" class="btn-clear" (click)="searchTerm = ''">Cancella</button>
      </div>

      <!-- Desktop Table View -->
      <div class="card table-card desktop-only">
        <table class="data-table">
          <thead>
            <tr>
              <th>Numero</th>
              <th>Tipo</th>
              <th>Cliente</th>
              <th>Emissione</th>
              <th>Scadenza</th>
              <th>Stato</th>
              <th>Totale</th>
              <th style="text-align: right;">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let f of filteredFatture">
              <td><strong>{{ f.numero }}</strong></td>
              <td>
                <span class="badge" [ngClass]="'badge-' + f.tipo">
                  {{ f.tipo === 'fattura_proforma' ? 'Proforma' : 'Fattura' }}
                </span>
              </td>
              <td>{{ f.cognome }} {{ f.nome }}</td>
              <td>{{ f.data_emissione | date:'dd/MM/yyyy' }}</td>
              <td>{{ f.data_scadenza ? (f.data_scadenza | date:'dd/MM/yyyy') : '-' }}</td>
              <td>
                <span class="badge" [ngClass]="'badge-' + f.stato">{{ f.stato }}</span>
              </td>
              <td><strong>€ {{ f.importo_totale | number:'1.2-2' }}</strong></td>
              <td style="text-align: right;">
                <a [routerLink]="['/fatture', f.id]" class="btn-sm" title="Visualizza Dettagli">
                  <span class="material-icons" style="font-size: 16px;">visibility</span>
                </a>
                <button class="btn-sm btn-danger" (click)="deleteFattura(f.id!)" title="Elimina">
                  <span class="material-icons" style="font-size: 16px;">delete</span>
                </button>
              </td>
            </tr>
            <tr *ngIf="filteredFatture.length === 0">
              <td colspan="8" class="text-center">Nessuna fattura trovata.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile Card View -->
      <div class="mobile-only mobile-card-list">
        <div class="mobile-item-card card" *ngFor="let f of filteredFatture">
          <div class="mobile-card-header">
            <strong>{{ f.numero }}</strong>
            <span class="badge" [ngClass]="'badge-' + f.stato">{{ f.stato }}</span>
          </div>
          <div class="mobile-card-body">
            <p><strong>Cliente:</strong> {{ f.cognome }} {{ f.nome }}</p>
            <p><strong>Tipo:</strong> {{ f.tipo === 'fattura_proforma' ? 'Proforma' : 'Fattura' }}</p>
            <p><strong>Emissione:</strong> {{ f.data_emissione | date:'dd/MM/yyyy' }}</p>
            <p><strong>Totale:</strong> € {{ f.importo_totale | number:'1.2-2' }}</p>
          </div>
          <div class="mobile-card-footer">
            <a [routerLink]="['/fatture', f.id]" class="btn-sm" style="width: auto; padding: 6px 12px;">Dettagli</a>
            <button class="btn-sm btn-danger" (click)="deleteFattura(f.id!)" style="width: auto; padding: 6px 12px;">Elimina</button>
          </div>
        </div>
        <div class="text-center" *ngIf="filteredFatture.length === 0">Nessuna fattura trovata.</div>
      </div>
    </div>
  `,
  styles: [`
    .page-container { max-width: 1280px; margin: 0 auto; }
    .header-flex { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; flex-wrap: wrap; gap: 12px; }
    h1 { margin: 0; color: var(--text-main); font-size: 26px; font-weight: 700; letter-spacing: -0.5px; }
    .subtitle { color: var(--text-muted); margin: 4px 0 0; font-size: 14px; }
    
    .search-bar { display: flex; align-items: center; gap: 12px; padding: 12px 20px; margin-bottom: 24px; border-radius: 12px; }
    .search-bar .search-icon { color: var(--text-muted); }
    .search-bar input { border: none; background: transparent; font-size: 15px; width: 100%; color: var(--text-main); outline: none; }
    .btn-clear { background: var(--border); border: none; padding: 4px 10px; border-radius: 6px; cursor: pointer; font-size: 12px; color: var(--text-muted); }

    .table-card { padding: 0; overflow: hidden; border-radius: 12px; border: 1px solid var(--border); }
    .data-table { width: 100%; border-collapse: collapse; text-align: left; }
    .data-table th, .data-table td { padding: 16px 20px; border-bottom: 1px solid var(--border); font-size: 14px; }
    .data-table th { background: var(--bg-main); color: var(--text-muted); font-weight: 600; text-transform: uppercase; font-size: 12px; letter-spacing: 0.5px; }
    .data-table tbody tr { transition: background 0.15s; }
    .data-table tbody tr:hover { background: var(--bg-main); }
    
    .btn-primary { display: inline-flex; align-items: center; gap: 6px; background: var(--primary); color: white; border: none; padding: 10px 18px; border-radius: 8px; text-decoration: none; font-weight: 600; font-size: 14px; transition: background 0.2s; box-shadow: 0 2px 4px rgba(37,99,235,0.2); }
    .btn-primary:hover { background: var(--primary-dark); }
    
    .btn-sm { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 6px; border: 1px solid var(--border); background: var(--surface); color: var(--text-muted); text-decoration: none; cursor: pointer; transition: all 0.2s; margin-right: 6px; }
    .btn-sm:hover { background: var(--bg-main); color: var(--text-main); }
    .btn-danger { background: rgba(239, 68, 68, 0.1); border-color: rgba(239, 68, 68, 0.2); color: var(--danger); }
    .btn-danger:hover { background: var(--danger); color: white; }
    
    .badge-fattura { background: rgba(55, 48, 163, 0.15); color: var(--primary); }
    .badge-fattura_proforma { background: rgba(134, 25, 143, 0.15); color: #c084fc; }

    .text-center { text-align: center; color: var(--text-muted); padding: 40px !important; }

    /* Mobile Card List */
    .mobile-only { display: none !important; }
    .desktop-only { display: block !important; }
    .mobile-card-list { display: flex; flex-direction: column; gap: 12px; }
    .mobile-item-card { padding: 16px; display: flex; flex-direction: column; gap: 10px; }
    .mobile-card-header { display: flex; justify-content: space-between; align-items: center; }
    .mobile-card-body p { margin: 4px 0; font-size: 13px; color: var(--text-muted); }
    .mobile-card-footer { display: flex; gap: 8px; margin-top: 8px; }

    @media (max-width: 768px) {
      .desktop-only { display: none !important; }
      .mobile-only { display: flex !important; }
    }
  `]
})
export class FattureComponent implements OnInit {
  fatture: Fattura[] = [];
  searchTerm = '';

  constructor(
    private apiService: ApiService,
    private toastService: ToastService,
    private confirmService: ConfirmService
  ) {}

  ngOnInit() {
    this.loadFatture();
  }

  get filteredFatture(): Fattura[] {
    if (!this.searchTerm.trim()) return this.fatture;
    const term = this.searchTerm.toLowerCase();
    return this.fatture.filter(f =>
      f.numero?.toLowerCase().includes(term) ||
      f.nome?.toLowerCase().includes(term) ||
      f.cognome?.toLowerCase().includes(term) ||
      f.stato?.toLowerCase().includes(term)
    );
  }

  loadFatture() {
    this.apiService.getFatture().subscribe({
      next: (data) => this.fatture = data,
      error: (err) => console.error('Errore caricamento fatture', err)
    });
  }

  async deleteFattura(id: number) {
    const confirmed = await this.confirmService.confirm(
      'Elimina Fattura',
      'Sei sicuro di voler eliminare questa fattura?',
      'Elimina',
      'Annulla',
      true
    );
    if (confirmed) {
      this.apiService.deleteFattura(id).subscribe({
        next: () => {
          this.toastService.success('Fattura eliminata con successo');
          this.loadFatture();
        },
        error: (err) => this.toastService.error(err.error?.error || 'Errore eliminazione fattura')
      });
    }
  }
}
